export default __webpack_public_path__ + "static/media/37t.24e22e0d.jpg";